import React from "react";
import { OVERVIEW } from "../../../../core/theme/reportTheme";
import TopCards from "./components/TopCards";
import TileRow from "./components/TileRow";
import { FactRow } from "./components/StatsAndFacts";
import AdvertiserTable from "./components/AdvertiserTable";
import CompetitionTypeCard from "./components/CompetitionTypeCard";
import GapsPanel from "./components/GapsPanel";
import KeywordMapPanel from "./components/KeywordMapPanel";
import Expandable from "../../components/Expandable";

// Market Overview: draws a marketOverview() result and nothing else.
// Top to bottom: search volume / benchmarks / data used, the tile row (your
// searches · Google page layout · other platforms), the three panels,
// Ada observed, then the full-width table (highlighted advertisers in yellow).
// The page scrolls; each panel and the table scroll inside themselves.
export default function OverviewPage({ overview, onSetType, onOpenAdvertiser, highlightKeys }) {
  return (
    <div className={OVERVIEW.page}>
      <TopCards result={overview} />
      <TileRow result={overview} />
      <div className={OVERVIEW.panelRow}>
        <Expandable className={OVERVIEW.panelSlot}>
          {(button, expanded) => <CompetitionTypeCard result={overview} expandButton={button} expanded={expanded} />}
        </Expandable>
        <Expandable className={OVERVIEW.panelSlot}>
          {button => <GapsPanel result={overview} expandButton={button} />}
        </Expandable>
        <Expandable className={OVERVIEW.panelSlot}>
          {(button, expanded) => <KeywordMapPanel result={overview} expandButton={button} expanded={expanded} />}
        </Expandable>
      </div>
      <FactRow result={overview} />
      <Expandable className={OVERVIEW.tableSlot}>
        {button => <AdvertiserTable result={overview} onSetType={onSetType} onOpenAdvertiser={onOpenAdvertiser} highlightKeys={highlightKeys} expandButton={button} />}
      </Expandable>
    </div>
  );
}
